import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";

export function CashOptionsPage() {
  const { disclosures, creditInfo, due } = useCredit();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  const [isLoading, setIsLoading] = useState(true);

  const features = [
    {
      title: "Bancolombia",
      img: "/png/bancolombia-completo.png",
      href:
        data?.extendPlazo === true ? `/pago-efectivo-extend` : `/pago-efectivo`,
      button: "Pagar ahora",
      wompiPay: false,
      isExtend: data?.extendPlazo,
    },
    {
      title: "Efecty",
      img: "/png/efecty.png",
      href:
        data?.extendPlazo === true
          ? `/pago-efectivo-extend`
          : `/pago-efectivo-efecty`,
      button: "Ver más",
      wompiPay: false,
      isExtend: data?.extendPlazo,
    },
    {
      title: "Wester Union",
      img: "/png/wu-accival.png",
      href:
        data?.extendPlazo === true
          ? `/pago-efectivo-extend`
          : `/pago-efectivo-wu`,
      button: "Ver más",
      wompiPay: false,
      isExtend: data?.extendPlazo,
    },
  ];

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"2"}
          title={"Elige tu corresponsal"}
          disclosures={disclosures}
          creditInfo={creditInfo}
          due={due}
          main={
            <>
              <div className="block px-6 lg:px-0 md:grid md:grid-cols-3 gap-4 content-center py-8 md:pt-20 h-full">
                <div className="block h-30 py-10 my-10 md:h-48 rounded-md transition shadow-lg p-4 bg-white hover:bg-purple hover:text-white">
                  <div className="flex  h-full">
                    <div className="block md:grid content-center text-lg font-bold mx-auto">
                      <div className="flex gap-2">
                        <SkeletonDahsboard
                          variant={"circular"}
                          height={30}
                          width={30}
                        />
                        <SkeletonDahsboard height={30} width={120} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="block h-30 py-10 my-10 md:h-48 rounded-md transition shadow-lg p-4 bg-white hover:bg-purple hover:text-white">
                  <div className="flex  h-full">
                    <div className="block md:grid content-center text-lg font-bold mx-auto">
                      <div className="flex gap-2">
                        <SkeletonDahsboard
                          variant={"circular"}
                          height={30}
                          width={30}
                        />
                        <SkeletonDahsboard height={30} width={120} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="block h-30 py-10 my-10 md:h-48 rounded-md transition shadow-lg p-4 bg-white hover:bg-purple hover:text-white">
                  <div className="flex  h-full">
                    <div className="block md:grid content-center text-lg font-bold mx-auto">
                      <div className="flex gap-2">
                        <SkeletonDahsboard
                          variant={"circular"}
                          height={30}
                          width={30}
                        />
                        <SkeletonDahsboard height={30} width={120} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <DashboardMyCredit
        current={"2"}
        name={data?.name}
        balance={data?.amount}
        title={"Elige tu corresponsal"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <>
            <div className="">
              <div className="block px-6 lg:px-0 md:grid md:grid-cols-3 gap-4 content-center py-8 md:pt-20 h-full">
                {features.map((feature) => (
                  <a
                    target={feature.wompiPay ? "_blank" : "_self"}
                    key={feature.title}
                    href={feature.href}
                    className={
                      "block h-30 py-10 my-10 md:h-48 rounded-md transition shadow-lg p-4 bg-white hover:bg-purple hover:text-white"
                    }
                  >
                    <div
                      key={feature.title}
                      className={feature.classTitle || "flex  h-full"}
                    >
                      <div className="block md:grid content-center text-lg font-bold mx-auto">
                        <img
                          className="w-auto h-12 mr-2"
                          src={feature.img}
                          alt="medios-de-pago-galilea"
                        />
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </>
        }
      />
    </Fragment>
  );
}
